import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import VoucherComponent from '../components/voucher.component';
import { selectVouchersQueryItems } from '../../../../../../redux/fms/vouchers/selector';
import { vouchers } from '../../../../../../redux/fms/vouchers/action';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectBankConfigurationsListItems } from '../../../../../../redux/bank-configurations/selector';
import { bankConfigurations } from '../../../../../../redux/bank-configurations/action';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectAccountLedgersListItems } from '../../../../../../redux/account-ledgers/selector';
import { grns } from '../../../../../../redux/grns/action';
import { selectGrnsListItems } from '../../../../../../redux/grns/selector';
import { selectSuppliersListItems } from '../../../../../../redux/suppliers/selector';
import { suppliers } from '../../../../../../redux/suppliers/action';

const ManagementVoucher = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const vouchersQueryData = useSelector(selectVouchersQueryItems)
  const libraryItemsData = useSelector(selectListItems)
  const bankConfigurationsListData = useSelector(selectBankConfigurationsListItems)
  const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)
  const accountledgersItems = useSelector(selectAccountLedgersListItems)
  const grnsListItems = useSelector(selectGrnsListItems)
  const supplierListItems = useSelector(selectSuppliersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectedVouchers, setSelectedVouchers] = useState<any>([])

  const fetchVouchersQueryById = () => {
    dispatch(vouchers.query({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/vouchers/query`,
      entity: 'vouchers',
      jsonData:
      {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedVouchers({ ...selectedVouchers, [field]: event });
  }

  useEffect(() => {
    dispatch(bankConfigurations.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations/list`,
      entity: 'bankConfigurations',
      jsonData: {}
    })).then(() => {
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
        entity: 'organizationUnits',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(accountLedgers.list({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
        entity: 'accountLedgers',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(suppliers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/e-procurement/suppliers/list`,
        entity: 'suppliers',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchVouchersQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  const fetchInvoiceNumberListByLedgersId = (ledgerId) => {
    dispatch(grns.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/e-procurement/grns/invoice-numbers`,
      entity: 'grns',
      jsonData:
      {
        Records: [
          {
            LedgerId: ledgerId
          }
        ]
      }
    }))
  }

  useEffect(() => {
    if (selectedVouchers?.LedgerId) {
      fetchInvoiceNumberListByLedgersId(selectedVouchers.LedgerId);
    }
  }, [selectedVouchers?.LedgerId]);

  useEffect(() => {
    if (isQuery) {
      setSelectedVouchers(vouchersQueryData?.result?.items)
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(vouchers.resetAction({ actionType: 'update' }))
      await dispatch(vouchers.update({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/vouchers`,
        entity: 'vouchers',
        jsonData:
        {
          Records: [
            {
              ...selectedVouchers
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(vouchers.resetAction({ actionType: 'create' }))
      await dispatch(vouchers.create({
        url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/vouchers`,
        entity: 'vouchers',
        jsonData:
        {
          Records: [
            {
              ...selectedVouchers
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/fms/vouchers')
  }

  return (
    <>
      {vouchersQueryData?.isLoading ? <PageLoader /> :
        <VoucherComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedVouchers={selectedVouchers}
          back={back}
          handleFormSubmit={handleFormSubmit}
          voucherTransactionTypeList={libraryItemsData?.result?.VoucherTransactionType}
          voucherSourceOfPaymentList={libraryItemsData?.result?.VoucherSourceOfPayment}
          paymentTransactionTypeList={libraryItemsData?.result?.PaymentTransactionType}
          paymentReferanceTypeList={libraryItemsData?.result?.PaymentReferanceType}
          bankConfigurationsList={bankConfigurationsListData?.result?.items}
          organizationUnitsList={organizationUnitsItems?.result?.items}
          ledgersList={accountledgersItems?.result?.items}
          supplierNameList={supplierListItems?.result?.items}
          invoiceNumbersList={grnsListItems?.result?.items}
        />
      }
    </>
  )
}

export default ManagementVoucher;